import { StatusCodes } from 'http-status-codes';

import ApiService from 'services/ApiService/ApiService';
import getMessagingServiceInstance, { MessagingService } from 'services/MessagingService/MessagingService';
import { GAME_SAVED, TIP_MENU_START, TIP_MENU_STOP } from 'services/MessagingService/EventNames';
import parseCatch from 'utils/parseCatch';
import { translate } from 'services/i18nService';
import NotificationService from 'services/NotificationService';
import {
  computeEndpoint,
  TIP_MENU_ACTION_URL,
  TIP_MENU_START_URL,
  TIP_MENU_STOP_URL,
  UPDATE_GAME_SETTINGS_URL,
  Payload,
} from 'services/GamesService/GamesService';
import { User } from 'stores/UserStore/UserStore.types';


export default class TipMenu {
  messagingService: MessagingService;

  constructor() {
    this.messagingService = getMessagingServiceInstance();
  }

  start = async(username: string, apiToken: string, options: Payload) => {
    const url = computeEndpoint(username, TIP_MENU_START_URL);
    const data = {
      token: apiToken,
      o: options,
    };

    try {
      const response = await ApiService.post(url, {
        data,
        withCredentials: false,
      });
      if (response.status >= StatusCodes.OK && response.status < StatusCodes.MULTIPLE_CHOICES) {
        this.messagingService.emit(TIP_MENU_START);
      }
    } catch (error) {
      parseCatch(error);
    }
  };

  stop = async(user: User, apiToken: string) => {
    const { username, userId } = user;
    const url = computeEndpoint(username, TIP_MENU_STOP_URL);

    const data = {
      token: apiToken,
      userName: username,
      userId,
    };

    try {
      const response = await ApiService.post(url, {
        data,
        withCredentials: false,
      });
      if (response.status >= StatusCodes.OK && response.status < StatusCodes.MULTIPLE_CHOICES) {
        this.messagingService.emit(TIP_MENU_STOP);
      }
    } catch (error) {
      parseCatch(error);
    }
  };

  action = async({ roomName, apiToken, index, showOnScreenNotification }:
    { roomName: string; apiToken: string; index: number; showOnScreenNotification: boolean }
  ) => {
    const url = computeEndpoint(roomName, TIP_MENU_ACTION_URL);
    const data = {
      token: apiToken,
      i: index,
    };

    try {
      await ApiService.post(url, {
        data,
        withCredentials: false,
      });
      if (showOnScreenNotification) {
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.SUCCESS,
          text: translate('v2profile.tipping.tip.sent'),
        });
      }
    } catch (error) {
      parseCatch(error);
    }
  };

  saveSettings = async({ token, username, ...rest }:
    { token: string; username: string; }
  ) => {
    const game = 'TipMenu';
    const url = ApiService.substitute(UPDATE_GAME_SETTINGS_URL, { game });
    const computedEndpoint = computeEndpoint(username, url);
    const data = {
      o: Object.values(rest),
      token,
    };

    try {
      const response = await ApiService.post(computedEndpoint, {
        data,
        withCredentials: false,
      });
      if (response.status >= StatusCodes.OK && response.status < StatusCodes.MULTIPLE_CHOICES) {
        this.messagingService.emit(GAME_SAVED);
        NotificationService.create({
          type: NotificationService.type.TOAST,
          subtype: NotificationService.subtype.SUCCESS,
          text: translate('v2broadcast.changes.saved'),
        });
      }
    } catch (error) {
      parseCatch(error);
    }
  };
}
